<template>
  <div class="notFound mt-5 pt-5">
    <div class="mt-5 pt-5">
      <h1>404</h1>
      <p>الصفحة غير موجودة !</p>
      <b-button variant="brand" aria-label="العودة للصفحة الرئيسية" @click="goToHome()">العودة للصفحة الرئيسية</b-button>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      goToHome() {
        this.$router.push({
          name: "landingPage"
        })
      }
    } 
  }
</script>
<style scoped>
.notFound{
  width: 100% !important;
  padding-top: 100px;
  text-align: center;
  color: #233245;
}
.notFound h1{
  font-size: 120px;
  font-weight: bold;
}
.notFound p{
  font-size: 25px;
  font-weight: bold;
}
</style>
